export type SentenceExerciseStateModel = typeof sentenceExerciseStateModel;

const sentenceExerciseStateModel = {
  currentSentence: '',
  currentSentenceInArrayOfObjects: [],
  currentSentenceInArray: [],
  shuffledSentenceInArrayOfObjects: [],
  currentSentenceChoices: [],
  currentSuggestedWord: {},
  nextWord: '',
  blankedWords: [],
  toNextSentence: false,
  blankedLettersInSentence: [],
  ExtraWords: ['Hi', 'Bye', 'Test', 'Go', 'There', 'Come'],
};

export default sentenceExerciseStateModel;
